import Navigation from "../components/Navigation";
import Publications from "../components/Publications";
import LanguageSwitcher from "../components/LanguageSwitcher";
import CookieNotice from "../components/CookieNotice";

const PublicationsPage = () => {
  return (
    <Navigation>
      {/* Language Switcher */}
      <LanguageSwitcher />

      {/* Cookie Notice */}
      <CookieNotice />

      <main className="min-h-screen bg-white">
        <Publications />
      </main>
    </Navigation>
  );
};

export default PublicationsPage;
